/**
 * The refusals the server names, and that both clients have a string for.
 *
 * The spend ceilings matter as much as the code failures: without them a
 * rate-limited user is told "something went wrong" — untrue, and it invites an
 * immediate retry, which is the one thing that cannot work. Found by hitting
 * the limit for real.
 */
const KNOWN_ERRORS = [
  'invalid-phone', 'cooldown', 'daily-limit', 'send-failed',
  'invalid-code', 'expired', 'too-many-attempts',
  'ip-limit', 'global-limit',
];

/**
 * Maps a server refusal onto a key that exists in both bundles. Anything not
 * in KNOWN_ERRORS — not-found, invalid-code-format, provider-error,
 * unparseable — falls through to `auth.errors.unknown`, which reads "something
 * went wrong, try again" rather than "check your code": telling someone to
 * recheck a code when the provider itself failed would be a lie.
 *
 * Shared by both clients so a refusal never reads differently on the web than
 * it does on the phone.
 */
export function otpErrorKey(err: unknown): string {
  const raw = (err && typeof err === 'object' && 'message' in err)
    ? String((err as { message: unknown }).message)
    : '';
  const hit = KNOWN_ERRORS.find((k) => raw.includes(k));
  return `auth.errors.${hit ?? 'unknown'}`;
}
